const storeSetting = {
    path: 'storeSetting',
    name: 'storeSetting',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'setting',
        icon: 'HSIconfont hs-icon-code',
        showRealm: ['NORMAL']
    },
    children: [
        {
            path: 'storeSettingMailConfig',
            name: 'storeSettingMailConfig',
            component: () => import('@/views/storeSettingMailConfig'),
            meta: { code: 'setting:mailConfig' }
        },
        {
            path: 'storeSettingSetWorConfig',
            name: 'storeSettingSetWorConfig',
            component: () => import('@/views/storeSettingSetWorConfig'),
            meta: { code: 'setting:changeSetWorStrategyV2' }
        },
        {
            path: 'storeSettingEslAttrConfig',
            name: 'storeSettingEslAttrConfig',
            component: () => import('@/views/storeSettingEslAttrConfig'),
            meta: { code: 'setting:storeEslConfig' }
        },
        {
            path: 'storeSettingMoveConfig',
            name: 'storeSettingMoveConfig',
            component: () => import('@/views/storeSettingMoveConfig'),
            meta: { code: 'setting:storemoveConfig' }
        },
    ]

};

export default storeSetting;